export default{
  methods: {
    getCEP(cep) {
      cep = cep.replace(/\D/g,'');
      if (/^[0-9]{8}$/.test(cep)) {
        return new Promise((resolve, reject) => {
          this.$http.get("https://viacep.com.br/ws/" + cep + "/json/")
            .then(r => r.data)
            .then(endereco => {
              if (!endereco.erro) {
                resolve({...endereco});
              } else {
                reject(new Error("Endereço não encontrado"));
              }
            })
            .catch(function (error) {
              reject(error);
            });
        });
      } else {
        return Promise.reject(new Error("CEP inválido"));
      }
    },
  },
  
}